import { render } from "./TableHeaderWithIcon.vue?vue&type=template&id=e1bc71c0"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./TableHeaderWithIcon.vue?vue&type=style&index=0&id=e1bc71c0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script